import { Question } from "../../../../utils/interface/exam";

interface QuestionDataProps {
    question: Question;
}

export default function QuestionData(props: QuestionDataProps) {

    const { question } = props;

    if(!question.data){
        return null;
    }

    switch (question.data?.type) {
        case 'image':
            return (
                <div className="question_data">
                    <img src={question.data.value} alt="Question" />
                </div>
            )

        default:
            return <></>
    }

}